<template>
  <!--
      	作者：gmshop
      	时间：2019-06-04
      	描述：插件中心-优惠券-领取记录
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="优惠券名称">
          <el-input size="small" v-model="formInline.name" placeholder="请输入优惠券名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="门店ID">
          <el-input size="small" v-model="formInline.store_id" type="number" placeholder="请输入门店ID"></el-input>
        </el-form-item> -->
        <el-form-item label="用户ID">
          <el-input size="small" v-model="formInline.user_id" type="number" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="small" v-model="formInline.mobile" type="number" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select size="small" v-model="formInline.coupon_type" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="满减券" :value="10"></el-option>
            <el-option label="折扣券" :value="20"></el-option>
            <el-option label="体验券" :value="30"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="已过期">
          <el-select size="small" v-model="formInline.is_expire" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="已过期" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="已使用">
          <el-select size="small" v-model="formInline.is_use" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="已使用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="领取时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.receive_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <!-- <el-button size="small" type="primary" v-auth="'/plus/coupon/coupon/receiveExport'" @click="onExport">导出</el-button> -->
        </el-form-item>

      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user.nickName" label="用户"></el-table-column>
            <el-table-column prop="coupon_id" label="优惠券ID"></el-table-column>
            <el-table-column prop="name" label="优惠券名称"></el-table-column>
            <el-table-column prop="coupon_type" label="优惠券类型"></el-table-column>
            <el-table-column prop="min_price" label="最低消费金额"></el-table-column>
            <el-table-column prop="seckill_stock" label="优惠方式">
              <template slot-scope="scope">
                <div v-if="scope.row.coupon_type.value==10">
                  <span>立减 <strong class="orange">{{scope.row.reduce_price}}</strong> 元</span>
                </div>
                <div v-if="scope.row.coupon_type.value==20">
                  <span>打 <strong class="orange">{{scope.row.discount}}</strong> 折</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="seckill_stock" label="有效期">
              <template slot-scope="scope">
                <div v-if="scope.row.expire_type==10">
                  <span>领取 <strong class="orange">{{scope.row.expire_day}}</strong> 天内有效</span>
                </div>
                <div v-if="scope.row.expire_type==20">
                  <span>
                    {{scope.row.start_time.text}}
                    ~
                    {{scope.row.end_time.text}}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="领取时间"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import CouponApi from '@/api/coupon.js';
  export default {
    data() {
      return {
        formInline: {
          user_id:'',
          name : '',
          coupon_type : '',
          is_expire : -1,
          is_use : -1,
          mobile : '',
          receive_date : '',
        },
        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        CouponApi.receiveList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getData()
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/Receive.vue